import { getBlindObjects } from '../../../helpers';

/**
 * Builder base para construir parámetros de productos financieros
 * @param {Object} values - Valores del formulario
 * @param {Object} config - Configuración específica del partner
 * @returns {Object} Parámetros construidos
 */
export const createParametersBuilder =
    (config = {}) =>
    (values) => {
        const {
            parameters,
            parameters_commission_credit,
            parameters_hitch,
            parameters_rate,
            type_algorithm,
        } = values;

        const blind_objects = getBlindObjects(values);
        const is_commission_percentage =
            parameters_commission_credit.unit === 0 ? true : false;
        const is_percentage = parameters_hitch.unit === 0 ? true : false;
        const terms = parameters.terms.join();

        const {
            annual_increase = 0,
            dealer_fee = 0,
            ppa_type,
            shared_savings_type,
            tax = 0,
        } = parameters;

        const baseParameters = {
            annual_increase,
            blind_objects,
            commission_credit: parameters_commission_credit.value,
            dealer_fee,
            hitch: parameters_hitch.value,
            is_commission_percentage,
            is_percentage,
            opening_commission_vat:
                parameters_commission_credit.opening_commission_vat,
            rate: parameters_rate.value,
            tax,
            terms,
        };

        // Soporte para algoritmos PPA
        if (type_algorithm === 'ppa_sunwise') {
            baseParameters.ppa_type = ppa_type;
            baseParameters[ppa_type] = parameters[ppa_type];
        }

        // Soporte para algoritmos Shared Savings
        if (type_algorithm === 'shared_savings') {
            baseParameters.shared_savings_type = shared_savings_type;
            baseParameters[shared_savings_type] =
                parameters[shared_savings_type];
        }

        // Permitir extensiones del partner
        if (config.extendParameters) {
            return config.extendParameters(baseParameters, values, parameters);
        }

        return baseParameters;
    };

/**
 * Builder por defecto sin extensiones
 */
export const buildParameters = createParametersBuilder();
